import { useEffect, useRef } from "react";

export function usePolling(fn, intervalMs = 10000) {
  const saved = useRef(fn);
  saved.current = fn;
  useEffect(() => {
    const run = () => {
      if (document.visibilityState === "visible") saved.current();
    };
    const id = setInterval(run, intervalMs);
    document.addEventListener("visibilitychange", run);
    window.addEventListener("focus", run);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", run);
      window.removeEventListener("focus", run);
    };
  }, [intervalMs]);
}
